import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateRemoteRefreshExpectedDurationParams {
  id: string;
  expectedRefreshDuration: string;
}

export class UpdateRemoteRefreshExpectedDurationRequest extends Request<IUpdateRemoteRefreshExpectedDurationParams, IResult> {
  constructor(params: IUpdateRemoteRefreshExpectedDurationParams) {
    super('setDatasourceRemoteExpectedRefreshDuration', params);
  }
}
